import { activationStates } from "../../variables/activations";
import InputField from "components/fields/InputField";

const macAddressRegex = /^([0-9A-Fa-f]{0,2}([-:]?)){0,5}[0-9A-Fa-f]{0,2}?$/;

const MacAddressesInput = (props) => {
    const { title, placeholder, state, setState, target } = props;

    const macAddressUpdate = (e) => {
        setState((state) => ({
            ...state,
            data: {
                ...state.data,
                [target]: {
                    ...state.data[target],
                    [e.target.name]: e.target.value,
                },
            },
        }));
    };

    return (
        <div>
            <label
                htmlFor="price"
                className="block text-sm font-medium leading-6 text-gray-900"
            >
                {title}
            </label>
            <div className="w-1/2">
                {Object.keys(state.data[target]).map((val, key) => {
                    return (
                        <InputField
                            key={key}
                            extra="mb-4"
                            label={
                                "Interfaccia " +
                                val +
                                (val === "eth0" ? "*" : "")
                            }
                            placeholder={placeholder}
                            name={val}
                            type="text"
                            disabled={
                                target === "mac_addresses_backup"
                                    ? state?.data?.is_hw_backup
                                    : state?.data?.is_hw
                            }
                            value={
                                state?.data[target]
                                    ? state?.data[target][val]
                                        ? state?.data[target][val]
                                        : ""
                                    : ""
                            }
                            onChange={(e) => {
                                if (macAddressRegex.test(e.target.value)) {
                                    macAddressUpdate(e);
                                }
                            }}
                            required={val === "eth0"}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default MacAddressesInput;
